import { type EmployerFeature } from '@factoryfixinc/ats-interfaces';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEmployerFeatureStore = defineStore('employer-feature', () => {
  const employerFeatures = ref<EmployerFeature[]>([]);

  // alphabetized list
  return { employerFeatures };
});
